module.exports = __webpack_public_path__ + "static/cleaning-service-6f27b3e010397a2d07f9a451ec3efc00.png";